import { useNavigate } from 'react-router-dom';
import {
  Section,
  ContentContainer,
  SectionSubtext,
  BenefitsGrid,
  BenefitCard,
  BenefitCardContent,
  BenefitIcon,
  BenefitText,
} from '../../styles';
import { BenefitsHeading, BenefitsSubtext, BenefitsCtaWrapper, BenefitsCTAButton } from './styles';
import { benefits } from '../../constants';

const BenefitsSection = () => {
  const navigate = useNavigate();

  return (
    <Section>
      <ContentContainer>
        <BenefitsHeading>Personalized Support for Your Unique Journey</BenefitsHeading>

        <BenefitsSubtext>
          Discover the benefits of working with experienced, certified hypnotherapists who guide you
          toward meaningful transformation in everyday life.
        </BenefitsSubtext>

        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitCard key={index}>
              <BenefitCardContent>
                <BenefitIcon src={benefit.icon} alt={benefit.title} />
                <BenefitText>{benefit.title}</BenefitText>
              </BenefitCardContent>
            </BenefitCard>
          ))}
        </BenefitsGrid>

        <SectionSubtext>...and more, in alignment with your personal goals.</SectionSubtext>

        <BenefitsCtaWrapper>
          <BenefitsCTAButton onClick={() => navigate('/services')} text="Explore Our Services" />
        </BenefitsCtaWrapper>
      </ContentContainer>
    </Section>
  );
};

export default BenefitsSection;
